<div class="dsg-json">
  <div class="dsg-json-toolbar">
    <label class="dsg-json-scope" matTooltip="Show only the selected layer">
      <input type="checkbox" [ngModel]="scoped()" (ngModelChange)="toggleScope()" />
      <span>Selection only</span>
    </label>

    <div class="dsg-json-toolbar-actions">
      <button type="button" class="dsg-json-icon" (click)="copy()" [matTooltip]="copied() ? 'Copied' : 'Copy JSON'">
        <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
      </button>
      <button type="button" class="dsg-json-icon" (click)="download()" matTooltip="Download .design.json">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </div>

  <textarea
    class="dsg-json-text"
    spellcheck="false"
    [ngModel]="text()"
    (ngModelChange)="onTextChange($event)"
    aria-label="Design document JSON"
  ></textarea>

  <p class="dsg-json-error" *ngIf="error()">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error() }}</span>
  </p>

  <!-- Non-blocking schema warnings — the document still renders with these. -->
  <details class="dsg-json-issues" *ngIf="issues().length">
    <summary>{{ issues().length }} warning{{ issues().length === 1 ? '' : 's' }}</summary>
    <ul>
      <li *ngFor="let issue of issues()">
        <code>{{ issue.path }}</code> — {{ issue.message }}
      </li>
    </ul>
  </details>

  <div class="dsg-json-footer">
    <span class="dsg-json-meta">{{ nodeCount() }} layers · {{ sizeLabel() }}</span>

    <div class="dsg-json-footer-actions" *ngIf="isEditing()">
      <button type="button" class="dsg-json-btn" (click)="revert()">Revert</button>
      <button type="button" class="dsg-json-btn is-primary" (click)="apply()">Apply</button>
    </div>
  </div>
</div>
